// extracted by mini-css-extract-plugin
export default {"logoBrand":"Logo_logoBrand__DrVXu","logoTracker":"Logo_logoTracker__RIju7","linkAlternative":"Logo_linkAlternative__UOuny"};